import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
// import { ActivatedRoute } from '@angular/router';

import { ViewBasePage } from '@shared/pages';
import { AccountProfileService, DealershipService, SmsSentMessagesService } from '@shared/services';
import { MyTimestampPipe } from '@shared/pipes';
import type { TAccountProfile, TDealership, TSmsSentMessage } from '@shared/models';

@Component({
    'selector': 'app-smssentmessages',
    'templateUrl': './smsSentMessages.page.html',
    'styleUrls': ['./smsSentMessages.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, MyTimestampPipe ]
})
export class SmsSentMessagesPage extends ViewBasePage implements OnInit, OnDestroy {
    public dealership: TDealership;
    public accountProfile: TAccountProfile;
    private subscription: any;
    public smsSentMessages: TSmsSentMessage[] = [];

    constructor(private accountProfileService: AccountProfileService, private dealershipService: DealershipService,
        private smsSentMessagesService: SmsSentMessagesService, injector: Injector) {
        super(injector);
    }

    public override async ngOnInit() {
        // Provide default values during the change detection cycle.
        this.accountProfile = this.accountProfileService.getNullable();
        this.dealership = this.dealershipService.getNullable();

        await this.uxHelperService.showSpinner();
        this.accountProfile = await this.accountProfileService.get();
        this.dealership = await this.dealershipService.get();

        // this.setMessageWidth
        const observable = this.smsSentMessagesService.getObservable('all');
        this.subscription = observable.subscribe((messages: TSmsSentMessage[]) => {
            this.smsSentMessages = this.smsSentMessagesService.sort(messages, false);
        });
        await this.uxHelperService.hideSpinner();
    }

    public override ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    private setMessageWidth(): void {
        // this.passwordRef.nativeElement.setAttribute('type', 'text');
        // this.passwordRef.nativeElement.setAttribute('type', 'password');

        // window.innerWidth = 
    }
}
